export const commaSeparatedString = (arr: string[]) => {
  const firstPart = arr.slice(0, -1).join(', ');
  const secondPart = arr.slice(-1);
  const conjunction =
    arr.length <= 1 ? '' : arr.length > 2 ? ', and ' : ' and ';

  return [firstPart, secondPart].join(conjunction);
};
